import { SPACE_OVERVIEW, WHITEBOARD_BOARD, WHITEBOARD_HOME } from '@confluence/named-routes';

import type { WhiteboardQueryParams } from '../whiteboard-bridge-api-type';
import type { WhiteboardLockoutState } from '../WhiteboardNavigationLockout';

type PushFn = (url: string, forceReload?: boolean) => void;
type LockoutStateHandler = (lockoutState: WhiteboardLockoutState) => void;

export class WhiteboardNavigationService {
	private lockoutStateHandler: LockoutStateHandler;
	private pushFn: PushFn;
	private spaceKey: string;

	constructor() {
		this.lockoutStateHandler = () => undefined;
		this.pushFn = () => undefined;
		this.spaceKey = '';
	}

	goToContent(id: string, query?: WhiteboardQueryParams) {
		this.pushFn(
			WHITEBOARD_BOARD.toUrl(
				{
					spaceKey: this.spaceKey,
					contentId: id,
				},
				{ query },
			),
		);
	}

	goToContentCreate() {
		this.pushFn(
			WHITEBOARD_BOARD.toUrl({
				spaceKey: this.spaceKey,
				contentId: 'new',
			}),
		);
	}

	goToHome() {
		this.pushFn(WHITEBOARD_HOME.toUrl({ spaceKey: this.spaceKey }));
	}

	goToContainer(containerKey: string) {
		this.pushFn(SPACE_OVERVIEW.toUrl({ spaceKey: containerKey }));
	}

	setPushFn(pushFn: PushFn) {
		this.pushFn = pushFn;
	}

	setSpaceKey(spaceKey: string) {
		this.spaceKey = spaceKey;
	}

	registerLockoutStateHandler(handler: LockoutStateHandler) {
		this.lockoutStateHandler = handler;
	}

	setLockoutState(lockoutState: WhiteboardLockoutState) {
		this.lockoutStateHandler(lockoutState);
	}
}
